import { IRequesterInfo } from "../../../../../base/models"
import { ClientProxy } from "../../../../../base/proxy/clientProxy"
import { IShipping, IShippingDatePreOrder } from "../models/models"


export class GetShippingDateApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'order/getShippingDate',
      requesterInfo,
    })
  }

  public async getShippingDate(request: IShippingDatePreOrder): Promise<IShipping> {
    return await this.postAsync<IShipping>(request)
  }
}
